import { Outlet } from 'react-router-dom';
import { SessionAuth } from 'supertokens-auth-react/recipe/session';

/**
 * A higher order component that wraps the <Outlet /> component
 * with a SuperTokens SessionAuth component. This component is
 * used to protect routes from unauthenticated access.
 * @returns {JSX.Element} A JSX element containing the Outlet
 * component wrapped with a SessionAuth component.
 */
const ProtectedRoutes = () => (
  <SessionAuth>
    <Outlet />
  </SessionAuth>
);

export default ProtectedRoutes;
